import { Injectable } from '@angular/core';

import * as moment from 'moment';

@Injectable()
export class DatepickerService {

    constructor() {

    }

    generateNgxpickerObject(stringDate) {

        var dateMoment = moment(stringDate);

        return {
            date: {
                year: dateMoment.year(),
                month: dateMoment.month() + 1,
                day: dateMoment.date()
            },
            formatted: dateMoment.format('YYYY-MM-DD')
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/datepicker.service.ts